import SearchIcon from '@atlaskit/icon/glyph/search';
import styled from 'styled-components';

export function NoResults() {
  return (
    <NoResultsWrapper>
      <SearchIcon label="Search" size="xlarge" />
      <h2>No results</h2>
    </NoResultsWrapper>
  );
}

const NoResultsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  height: 200px;
  color: var(--ds-text-subtle, #6b778c);
`;
